import * as crypto from "crypto-js";
export const AppMD5Hash = (params: string) => {
  return crypto.MD5(params).toString();
};
// export const AESEncryption = (params: string): string => {
//   return crypto.AES.encrypt(params, process.env.REACT_APP_SSO_CLIENT_ID).toString();
// };
